<script>
import {
  CdrGrid,
  CdrLink,
  CdrList,
  CdrImg,
  CdrText,
} from '@rei/cedar';

export default {
  name: 'BrandTopCategories',
  components: {
    CdrGrid,
    CdrLink,
    CdrList,
    CdrImg,
    CdrText,
  },
  props: {
    brandCategories: { type: Array, default: () => [] },
    brandName: { type: String, default: null },
  },
};

</script>
<template>
  <div class="brand-top-categories">
    <cdr-text
      class="brand-top-categories__heading"
      tag="h2"
    >
      Shop by category
    </cdr-text>
    <cdr-grid class="brand-top-categories__grid">
      <div
        v-for="(category, index) in brandCategories"
        :key="`${category.parent.name}-${index}`"
        span="6 4@sm"
      >
        <div>
          <cdr-list class="brand-top-categories__list">
            <li class="brand-top-categories__link-heading">
              <cdr-text
                tag="h4"
              >
                <cdr-link
                  :href="category.parent.link"
                  modifier="standalone"
                  class="brand-top-categories__primary-link"
                >
                  <cdr-img
                    v-if="category.image"
                    :src="category.image.src"
                    alt=""
                    class="brand-top-categories__image"
                    ratio="1/1"
                    fit="contain"
                  />
                  {{ category.parent.name }}
                </cdr-link>
              </cdr-text>
            </li>
            <li
              v-for="(child, i) in category.children"
              :key="`${child.name}-${i}`"
              data-ui="brand-top-categories--child-category"
            >
              <cdr-link
                :href="child.link"
                modifier="standalone"
                class="brand-top-categories__link"
              >
                <cdr-text
                  tag="p"
                >
                  {{ child.name }}
                </cdr-text>
              </cdr-link>
            </li>
          </cdr-list>
        </div>
      </div>
    </cdr-grid>
  </div>
</template>
<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
.brand-top-categories {

  &__heading {
    @include cdr-text-heading-serif-700;
    text-align: center;
    margin-bottom: $cdr-space-two-x;
  }

  &__image {
    display: block;
    max-width: 200px;
    margin: 0 auto;
    width: 100%;
  }

  &__grid {
    grid-template-columns: repeat(3, 1fr);

    @include cdr-xs-mq-only {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  ul {
    margin: $cdr-space-one-x 0;
  }

  &__primary-link {
    display: block;
    font-weight: 700;
    color: $cdr-color-text-primary;

    &:hover {
      color: $cdr-color-text-primary;
    }
  }

  &__link,
  &__link:hover {
    @include cdr-text-default;
    margin: 0;
    color: $cdr-color-text-primary;
  }
}
</style>
